<template>
  <div class="container py-4">

    <!-- Bouton retour -->
    <button class="btn btn-outline-secondary mb-4" @click="router.back()">
      ← Retour
    </button>

    <!-- Loader -->
    <div v-if="loading" class="text-center">
      Chargement...
    </div>

    <!-- Contenu -->
    <div v-else-if="publication">
      <h2 class="fw-bold mb-3">{{ publication.titre }}</h2>

      <p class="text-muted mb-2">
        Année : {{ publication.annepublication }}
      </p>

      <p class="mb-3"><strong>Auteur :</strong> {{ publication.auteur }}</p>
     

      <div 
        class="contenu"
        v-html="publication.contenu"
        style="white-space: pre-line;"
      ></div>
    </div>

    <!-- Message d'erreur -->
    <div v-else class="text-danger">
      Publication introuvable
    </div>

  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";

const route = useRoute();
const router = useRouter();

const publication = ref<any>(null);
const loading = ref(true);

const loadPublication = async () => {
  try {
    const { data } = await ApiService.get(`/publications/${route.params.id}`);
    publication.value = data.data;
  } catch (error) {
    console.error("Erreur chargement publication :", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadPublication();
});
</script>

<style scoped>
.container {
  max-width: 800px;
}

h2 {
  color: #0b1b3f;
}

p {
  font-size: 1rem;
}
.contenu{
  text-align: justify;
}
</style>
